import { Suspense, useEffect, useState } from "react";
import {
  TableFilters,
  TableFiltersState,
} from "../../../../common/components/ui/table/TableFilters";
import Loading from "../../../../common/components/ui/loading/Loading";
import GenericTable from "../../../../common/components/ui/table/GenericTable";
import TableFooter from "../../../../common/components/ui/table/TableFooter";
import { getCostCenters } from "../../../../common/services/purchaseCostCenter.api";
import { IPurchaseCostCenter } from "../../../../types/purchaseCostCenter";
import ModalCreateCostCenter from "../modals/ModalCreateCostCenter";
import { useNavigate } from "react-router-dom";

function TableCostCenter() {
  const [page, setPage] = useState<number>(1);
  const [data, setData] = useState({ itemsPerPage: 10, totalItems: 0 });
  const [costCenters, setCostCenters] = useState<IPurchaseCostCenter[]>([]);
  const [filters, setFilters] = useState<TableFiltersState>({
    search: "",
    status: [],
  });
  const EMPTY_ACTION = { eventName: "", data: undefined };
  const [action, setAction] = useState<{ eventName: string; data?: unknown }>(
    EMPTY_ACTION
  );

  const [isLoading, setIsLoading] = useState(false);
  const isAction = (eventName: string) => action.eventName === eventName;

  const cleanActionData = () => {
    handleSearch(filters);
    setAction(EMPTY_ACTION);
  };

  const handleSearch = ({ search, status }) => {
    const newState = Object.assign({}, filters, { search, status });
    setFilters(newState);
  };

  const navigate = useNavigate();

  useEffect(() => {
    async function loadCostCenters() {
      setIsLoading(true);
      const result = await getCostCenters({ ...filters, page });
      setData({
        itemsPerPage: data.itemsPerPage,
        totalItems: result.totalItems,
      });
      setCostCenters(result.data);
      setIsLoading(false);
    }
    loadCostCenters();
  }, [data.itemsPerPage, filters, page]);
  const handleFilterChange = (newFilters: Partial<TableFiltersState>) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };
  return (
    <Suspense fallback={<Loading />}>
      <div className="table-section">
        <TableFilters
          dashboardHeader="Centro de Custos"
          placeholder="Digite a descrição."
          statusOptions={{}}
          newItemLabel="Novo Centro de Custo"
          onNewItemClick={() =>
            setAction({ eventName: "create", data: undefined })
          }
          onSearch={handleFilterChange}
          entity="inventory-pieces"
          tableData={costCenters}
        />

        <GenericTable
          headers={{
            description: "Descrição",
          }}
          data={costCenters}
          renders={{
            description: (description, costCenter) => (
              <a
                href={`compras/centroDeCusto/${
                  (costCenter as IPurchaseCostCenter)._id
                }`}
                onClick={(e) => {
                  e.preventDefault(); // Para evitar o comportamento padrão do link
                  navigate(
                    `/compras/centroDeCusto/${
                      (costCenter as IPurchaseCostCenter)._id
                    }`
                  ); // Navegação na mesma página
                }}
                target="_blank" // Abre em uma nova aba
                rel="noopener noreferrer" // Melhoria de segurança
              >
                {description as string}
              </a>
            ),
          }}
        />

        {isLoading && <Loading />}

        <TableFooter
          page={page || 1}
          totalItems={data.totalItems || 0}
          itemsPerPage={data.itemsPerPage || 10}
          goToPage={setPage}
        />
      </div>
      {isAction("create") && (
        <ModalCreateCostCenter onClose={cleanActionData} />
      )}
    </Suspense>
  );
}

export default TableCostCenter;
